/* import p1 from '../assets/images/p1.jpg'
import p2 from '../assets/images/p2.jpg'
import p3 from '../assets/images/p3.jpg'
import p4 from '../assets/images/p4.jpg'
import p5 from '../assets/images/p5.jpg'
import p6 from '../assets/images/p6.jpg'
import id7 from '../assets/images/id7.jpg'
import id8 from '../assets/images/id8.jpg'
import id9 from '../assets/images/id9.jpg'
import id10 from '../assets/images/id10.jpg'
import id11 from '../assets/images/id11.jpg' */

const data =
{
    "productos": [
        
        {
            "id": 1,
            name : "Agility Gold Grandes Adultos ",
            "peso": "1.5 KG",
            "description": "Alimento super premium para perros, elaborado en Colombia bajo los mas altos estandares de calidad, sus excelentes fuentes de proteína garantizan una excelente asimilación de sus nutrientes. Enriquecido con vitaminas y minerales de fácil absorción. Contiene omegas tres y seis para una piel sana y un pelaje bello y brillante.",
            "price": 27750,
            "image": "https://raw.githubusercontent.com/DanielaTob/img/main/p1.jpg",
            "category": "Alimento"
        },

        {
            "id": 2,
            name: "Agility Gold Gatos",
            "peso": "1.5 KG",
            "description": "El concentrado para gatos Agility Gold es un concentrado ideal para suministrar en todas las etapas de la vida de los gatos. Su fórmula libre de granos será ideal para proporcionar una alimentación adecuada y una digestión más rápida. Contiene niveles equilibrados de minerales que favorecerán la salud renal y es perfecta para evitar la formación de las bolas de pelo.",
            "price": 33000,
            "image": "https://raw.githubusercontent.com/DanielaTob/img/main/p2.jpg",
            "category": "Alimento"
        },

        
        {
            "id": 3,
            name: "Chunky Pollo Gatos",
            "peso": "1.5 KG",
            "description": "Es un concentrado para gatos, cuya fórmula está hecha con carne de verdad, así que sus croquetas serán sabrosas y muy palatables para tu gato. Su fórmula esta especialmente diseñada para controlar las bolas de pelo y favorecer su digestión gracias a su alto nivel de fibra.",
            "price": 19800,
            "image": "https://raw.githubusercontent.com/DanielaTob/img/main/p3.jpg",
            "category": "Alimento"
        },

        
        {
            "id": 4,
            name: "Max Cat Adulto Pollo",
            "peso": "1 KG",
            "description": "Max cat adulto pollo y arroz, Sin la adición de colorantes, el alimento max cat adultos pollo & arroz trae ingredientes seleccionados por especialistas para proporcionarle una alimentación rica y balanceada a tu gatito.",
            "price": 19000,
            "image": "https://raw.githubusercontent.com/DanielaTob/img/main/p4.jpg",
            "category": "Alimento"
        },

        
        {
            "id": 5,
            name: "Chunky Pollo Adultos",
            "peso": "2 KG",
            "description": "Chunky Perro Adulto Pollo es un alimento para perros adultos de todas las razas, hecho con pollo de verdad. Esta dieta esta indicada para perros adultos y hasta los 7 años, con un delicioso sabor y olor a pollo que tu mascota no podrá resistir.",
            "price": 15700,
            "image": "https://raw.githubusercontent.com/DanielaTob/img/main/p5.jpg",
            "category": "Alimento"
        },

        
        {
            "id": 6,
            name: "Chunky Pollo Cachorro",
            "peso": "2 KG",
            "description": "Chunky cachorros pollo Comida para perros entre los 2 y 12 meses, elaborada con proteínas de excelente calidad y un sabor exquisito con un alto nivel de proteína proveniente de carne de pollo real que favorecerán su salud en general, la digestión, protegerán el tracto gastrointestinal y el mantenimiento óptimo de la piel y el pelaje.",
            "price": 18500,
            "image": "https://raw.githubusercontent.com/DanielaTob/img/main/p6.jpg",
            "category": "Alimento"
        },





        {
            "id": 7,
            name: "Bravecto - Perros De 20 Hasta 40 Kg",
            "peso": "1000 Mlg",
            "description": "Es un poderoso medicamento que trata y controla las infestaciones en perros de pulgas y garrapatas. También previene la transmisión de Bebesia Canis 12 semanas. Trata la demodicosis y sarna y infestaciones por ácaros. Peso entre 20-40 Kilogramos.",
            "price": 105100,
            "image": "https://raw.githubusercontent.com/DanielaTob/img/main/id7.jpg",
            "category": "Cuidado"
        },

        {
            "id": 8,
            name: "Bravecto - Perros De 10 Hasta 20 Kg",
            "peso": "500 Mlg",
            "description": "Bravecto mata las pulgas adultas y está indicado para el tratamiento y la prevención de infestaciones por pulgas (Ctenocephalides felis y C Canis) y para el tratamiento y el control de infestaciones por garrapatas (Rhipicephalus sanguineus) durante 12 semanas en perros y cachorros a partir de los 2 meses de edad.",
            "price": 82900,
            "image": "https://raw.githubusercontent.com/DanielaTob/img/main/id8.jpg",
            "category": "Cuidado"
        },

        {
            id: 9,
            name: "Bravecto Spot On - Perros De 2 Hasta 4,5 Kg",
            "peso": "0.4 ML",
            "description": "Bravecto Antiparasitario Spot on Perros de 2 a 4.5 Kg Solución tópica 112.5 mg. Este es un antiparasitario ideal para matar pulgas y garrapatas durante 12 semanas, puede usarse como tratamiento para controlar la dermatitis alérgica o las picaduras de las pulgas. Ideal para perros pequeños con peso de 2 a 4.5 kg.",
            "price": 78400,
            "image": "https://raw.githubusercontent.com/DanielaTob/img/main/id9.jpg",
            "category": "Cuidado"
        },

        {
            "id": 10,
            name: "Bravecto - Gatos De 1,2 Hasta 2,8 Kg",
            "peso": "0.4 ML",
            "description": "Antiparasitario de acción inmediata y persistente ideal para matar pulgas y garrapatas durante semanas, apto para usarse como tratamiento para controlar la dermatitis alérgica o las picaduras de las pulgas. Ideal para gatos pequeños con peso de 1.2 a 2.8 kg.",
            "price": 78400,
            "image": "https://raw.githubusercontent.com/DanielaTob/img/main/id10.jpg",
            "category": "Cuidado"
        },

        {
            "id": 11,
            name: "Bravecto Spot on - Gatos De 2,8 Hasta 6,2 Kg",
            "peso": "0.4 ML",
            "description": "Antiparasitario de acción inmediata y persistente ideal para matar pulgas y garrapatas durante semanas, apto para usarse como tratamiento para controlar la dermatitis alérgica o las picaduras de las pulgas. Ideal para gatos pequeños con peso de 2.8 a 6.2 Kg",
            "price": 85100,
            "image": "https://raw.githubusercontent.com/DanielaTob/img/main/id11.jpg",
            "category": "Cuidado"
        }

    ]
}

export default data;